module.exports = __webpack_public_path__ + "static/media/intellidigest.114436ca.jpg";